module.exports = __webpack_public_path__ + "img/sec__background.4215be4a.png";